<div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="save()">
        <mat-icon>save</mat-icon>
        <span class="hide-text">{{ 'button_name.save' | translate }}</span>
    </button>

    <button *ngIf="!hideSaveAndReturn" mat-raised-button color="primary" (click)="saveAndReturn()">
        <mat-icon>save</mat-icon>
        <span class="hide-text">{{ 'button_name.save_then_return' | translate }}</span>
    </button>
    <ng-content></ng-content>
</div>
